"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2Parser = void 0;
class V2Parser {
    constructor(manifest, includeDevDependencies) {
        this.version = '2';
        this.manifest = manifest;
        this.includeDevDependencies = !!includeDevDependencies;
    }
    pkgInfoFrom() {
        return {
            name: this.manifest.project.name,
            version: this.manifest.project.version,
        };
    }
    dependenciesFrom() {
        var _a, _b;
        const depsRegex = /^[a-zA-Z][a-zA-Z0-9_-]*/;
        const deps = this.manifest.project.dependencies || [];
        const newFormatDeps = deps
            .map((dep) => { var _a; return (_a = dep.match(depsRegex)) === null || _a === void 0 ? void 0 : _a[0]; })
            .filter((dep) => typeof dep === 'string') || [];
        const legacyFormatDeps = Object.keys(((_b = (_a = this.manifest.tool) === null || _a === void 0 ? void 0 : _a.poetry) === null || _b === void 0 ? void 0 : _b.dependencies) || []);
        return [...newFormatDeps, ...legacyFormatDeps];
    }
    getGroupDevDepNames(obj) {
        const groupDevDepNames = Object.values(obj)
            .map((group) => group.dependencies)
            .map((depsObj) => Object.keys(depsObj))
            .reduce((acc, curr) => [...acc, ...curr], []);
        return groupDevDepNames;
    }
    getAllDevDependencyNames() {
        var _a, _b, _c, _d, _e, _f, _g;
        // pre-v1.2.0 naming convention
        const devDepsProperty = Object.keys((_c = (_b = (_a = this.manifest.tool) === null || _a === void 0 ? void 0 : _a.poetry.group) === null || _b === void 0 ? void 0 : _b.dev.dependencies) !== null && _c !== void 0 ? _c : []);
        const legacyDevDepsProperty = Object.keys((_e = (_d = this.manifest.tool) === null || _d === void 0 ? void 0 : _d.poetry['dev-dependencies']) !== null && _e !== void 0 ? _e : []);
        // post-v1.2.0 dependency groups
        // https://python-poetry.org/docs/master/managing-dependencies
        // we will handle all tool.poetry.group.<group> as dev-deps
        const groupDevDepsProperty = ((_f = this.manifest.tool) === null || _f === void 0 ? void 0 : _f.poetry.group)
            ? this.getGroupDevDepNames((_g = this.manifest.tool) === null || _g === void 0 ? void 0 : _g.poetry.group)
            : [];
        return [
            ...devDepsProperty,
            ...groupDevDepsProperty,
            ...legacyDevDepsProperty,
        ];
    }
    getDependencies() {
        const dependencies = this.dependenciesFrom().map((dep) => ({
            name: dep,
            isDev: false,
        }));
        const devDependencies = (this.includeDevDependencies ? this.getAllDevDependencyNames() : []).map((devDep) => ({
            name: devDep,
            isDev: true,
        }));
        return [...dependencies, ...devDependencies].filter((pkg) => pkg.name != 'python');
    }
}
exports.V2Parser = V2Parser;
//# sourceMappingURL=v2Parser.js.map